export const Constants = {
UTM_SESSION_CHARACTERS:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"

}


